<mat-card class="filter settingHeader">
  <div class="name">
    Project Data Report
  </div>

  <button *ngIf="showDisplayColumn==true" class="viewBtn" mat-icon-button (click)="applyFilter(customize)" matTooltipClass="tooltip"
    matTooltip="Customize Column">
   <mat-icon>view_column</mat-icon>
  </button>

  <div class="projectSearch">
      
    <button class="searchbtn" [disabled]="value==''"  mat-icon-button aria-label="Clear">
      <mat-icon (click)="SearchFilter()">search</mat-icon>
    </button>
   
    <input placeholder="Search" type="text"  maxlength="50" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
   
    <button class="filterbtn" mat-icon-button (click)="applyAdvFilter(advFilter)"
    matTooltipClass="tooltip" matTooltip="Filters">
   <mat-icon>filter_list</mat-icon>
  </button>
 

 </div>


  <!-- <div class="quickAction">
    <mat-form-field class="example-form-field" appearence="fill">
      <mat-label>Search Record</mat-label>
      <input matInput type="text"  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
   
  </div> -->

</mat-card>

<mat-card class="documents" *ngIf="showCustomField==false">
  <table class="mat-table" *ngIf="!ShowNoRecordFound">
    <thead>
      <tr class="mat-header-row">
        <!-- <th class="mat-header-cell">SNo</th> -->
        <th class="mat-header-cell">From</th>
        <th class="mat-header-cell">Project Name</th>
        <th class="mat-header-cell">Date</th>
        <th class="mat-header-cell pEmail">Name</th>
        <th class="mat-header-cell pEmail">Participant Emails</th>
        <th class="mat-header-cell pEmail">Form Name</th>
        <th class="mat-header-cell">Office</th>
        <th class="mat-header-cell">Organization</th>
        <th class="mat-header-cell">Status</th>
        <th class="mat-header-cell">Docs link</th> 
        <th class="mat-header-cell">Docs</th>
        <th class="mat-header-cell">Type</th>   
        <th class="mat-header-cell">Action</th>     
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let project of projects; let i = index" class="mat-row">
        <!-- <td class="mat-cell">{{ i + 1 }}</td> -->
        <td class="mat-cell">             
          <p *ngIf="project.pType==0"><mat-icon matTooltip="Sign Now">border_color</mat-icon></p>
          <p *ngIf="project.pType==1"><mat-icon matTooltip="Fill">description</mat-icon></p> 
        </td> 
        <td class="mat-cell" *ngIf="project.participants" matTooltip="{{project.projectName}}" matTooltipClass="tooltip"><p>{{ project.projectName }}</p></td>
        <td class="mat-cell" *ngIf="!project.participants">--</td>
        <td class="mat-cell"  matTooltipClass="tooltip"><p>{{ project.createdOn | date: "MM/dd/yyyy"}}</p></td>
        <td class="mat-cell pEmail" matTooltip="{{project.name}}" matTooltipClass="tooltip"><p>{{ project.name }}</p></td>
        <td class="mat-cell pEmail" *ngIf="project.participants" matTooltip="{{project.participants}}" matTooltipClass="tooltip"><p>{{ project.participants }}</p></td>
        <td class="mat-cell " *ngIf="!project.participants">--</td>
        <td class="mat-cell pEmail"  matTooltip="{{project.formName}}" matTooltipClass="tooltip"><p>{{ project.formName }}</p></td>
        <td class="mat-cell"  matTooltip="{{project.officeName}}" matTooltipClass="tooltip"><p>{{ project.officeName }}</p></td>
        <td class="mat-cell"  matTooltip="{{project.orgName}}" matTooltipClass="tooltip"><p>{{ project.orgName }}</p></td>
        <td class="mat-cell" matTooltipClass="tooltip"><p>{{ project.projectStatus }}</p></td>
        <td class="mat-cell">
          <ng-container *ngFor="let link of project.linksToCompletedDocuent;let i=index" >
            <a class="multiLink" [href]="link" target="_blank">
              {{i+1}}              
            </a>
          </ng-container>
          
          <span *ngIf="project.linksToCompletedDocuent==null || project.linksToCompletedDocuent.length==0">--</span>
        </td>

        <td class="mat-cell">
          <button  color="primary" mat-icon-button *ngIf="project.linksToCompletedDocuent && project.linksToCompletedDocuent.length" (click)="downloadAsZip(project)">
            <mat-icon>folder_zip</mat-icon>
          </button>      
        </td>

        <td class="mat-cell">
          <p *ngIf="project.coreID>0"><mat-icon matTooltip="{{CoreShowName}}">app_registration</mat-icon></p>
          <p *ngIf="project.contactID>0"><mat-icon matTooltip="{{ContactShowName}}">contact_mail</mat-icon></p>
        </td>

        <td class="mat-cell">
          <button *ngIf="project.projectStatus !== 'Completed'" color="primary" mat-icon-button (click)="SendRemainder(project)">
          <mat-icon>notifications_active</mat-icon>
        </button>
        
         <button *ngIf="project.projectStatus == 'Completed'" color="primary" mat-icon-button matTooltip="Sync Documents"
         (click)="mapPlaceHolder(project)">
         <mat-icon>sync</mat-icon>
         </button>

       </td>
       
      </tr>
    </tbody>
  </table>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</mat-card>

<mat-card class="documents" *ngIf="showCustomField==true">

<div style="height: 78vh;overflow-x:auto;overflow-y:auto;"> 

  <table class="table" *ngIf="rowDataList.length>0">
    <!-- Header Row -->
    <thead>
      <tr>
        <th class="mat-header-cell date" *ngFor="let clm of showCustomColumninList">
          <span>{{ clm.fieldName }}</span>
        </th>
      </tr>
    </thead>
  
    <!-- Body Rows -->
    <tbody>
      <tr *ngFor="let rowData of rowDataList">
        <td class="mat-cell date " *ngFor="let clm of showCustomColumninList">

          <ng-container *ngIf="clm.fieldName== 'From'">
            <div class="from">
              <!-- <p *ngIf="rowData.coreID>0"><mat-icon matTooltip="Core">app_registration</mat-icon></p>
              <p *ngIf="rowData.contactID>0"><mat-icon matTooltip="Contact">contact_mail</mat-icon></p> -->
              <p *ngIf="rowData.pType==0"><mat-icon matTooltip="Sign Now">border_color</mat-icon></p>
              <p *ngIf="rowData.pType==1"><mat-icon matTooltip="Fill">description</mat-icon></p> 
            </div>
          </ng-container>

          <ng-container *ngIf="clm.fieldName!== 'Docs link' && 
          clm.fieldName!== 'Docs' &&  clm.fieldName!== 'Action' && clm.fieldName!== 'From'
          && clm.fieldName !== 'Type'">
            <p>
              {{ getFieldColumnValues(rowData, clm) }}
            </p>
          </ng-container>
           <!-- Docs link -->
    <ng-container *ngIf="clm.fieldName === 'Docs link'">
    <a class="multiLink"  *ngFor="let link of rowData.finalDocuments; let i = index" [href]="link" target="_blank">
      {{ i + 1 }}
    </a>
    <span *ngIf="!rowData.finalDocuments || rowData.finalDocuments.length === 0">--</span>

    
  </ng-container>

  <!-- Docs -->
  <ng-container *ngIf="clm.fieldName === 'Docs'">
    <button mat-icon-button color="primary" *ngIf="rowData.finalDocuments && rowData.finalDocuments.length" (click)="downloadAsZipProject(rowData)">
      <mat-icon>folder_zip</mat-icon>
    </button>
    <!-- <span *ngIf="!rowData.finalDocuments || rowData.finalDocuments.length === 0">--</span> -->
    <button mat-icon-button color="primary" *ngIf="rowData.pType==0"  matTooltip="Send Mail" (click)="resendEmailtoParticipants(rowData)">
      <mat-icon>send</mat-icon>
    </button>  
  </ng-container>

  <ng-container *ngIf="clm.fieldName === 'Type'">
    <p *ngIf="rowData.coreID>0"><mat-icon matTooltip="{{CoreShowName}}">app_registration</mat-icon></p>
    <p *ngIf="rowData.contactID>0"><mat-icon matTooltip="{{ContactShowName}}">contact_mail</mat-icon></p>
  </ng-container>

  <ng-container *ngIf="clm.fieldName === 'Action'">
    <button color="primary" mat-icon-button *ngIf="rowData.projectStatus !== 'Completed'"  (click)="SendRemainder(rowData)">
      <mat-icon>notifications_active</mat-icon>
    </button>
    <!-- <span *ngIf="rowData.projectStatus == 'Completed'">--</span> -->
    <button *ngIf="rowData.projectStatus == 'Completed'" color="primary" mat-icon-button matTooltip="Sync Documents"
    (click)="mapPlaceHolderCustom(rowData)">
    <mat-icon>sync</mat-icon>
     </button>
  </ng-container>

        </td>
      </tr>
    </tbody>

    
  </table>
  
 
  <div *ngIf="rowDataList.length==0" class="noRecordFound">No Record Found</div>
</div>

</mat-card>


<ng-template #advFilter>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
     Search
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>   
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders">    
      
      <mat-form-field appearance="" *ngIf="showSuperAdmin==true">
        <mat-label>Organization Name</mat-label>
        <mat-select placeholder = "Select Organization"  
          (selectionChange)="getOffice($event)">
           <mat-option *ngFor = "let data of OrgnizationList" 
              [value] = "data.organizationID">
              {{data.organizationName}}
           </mat-option>
        </mat-select>
      </mat-form-field> 

      <mat-form-field appearance="" *ngIf="showOrganizationAdmin==true">
        <mat-label>Office Name</mat-label>
        <mat-select placeholder = "Select Office" [(ngModel)]="selectedOfficeId" (selectionChange)="selectOffice($event)">
          <mat-option *ngFor = "let data of OrgOfficeList" 
             [value] = "data.officeID">
             {{data.officeName}}
          </mat-option>
       </mat-select>
      </mat-form-field> 

      <mat-form-field appearance="" *ngIf="showUserAdmin==true">
        <mat-label>User Name</mat-label>
        <mat-select placeholder = "Select User" [(ngModel)]="selecteduserId" (selectionChange)="selectUser($event)">
          <mat-option *ngFor = "let data of UsersList" 
             [value] = "data.uuid">
             {{data.firstName}} {{data.lastName}} 
          </mat-option>
       </mat-select>
      </mat-form-field> 

    <mat-form-field class="example-half-width">                
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" [(ngModel)]="emailAdvSearch">
    </mat-form-field>
       
  <mat-form-field appearance="">
    <mat-label>Form Name</mat-label>
    <mat-select (selectionChange)="formNameSelection($event)" [(ngModel)]="selectedFormId">
      <mat-option *ngFor="let form of formList" [value]="form.formID">
        {{ form.formName }}
      </mat-option>
    </mat-select>
  </mat-form-field> 

  <mat-form-field appearance="">
    <mat-label>Document Name</mat-label>
    <mat-select (selectionChange)="documentSelection($event)" [(ngModel)]="documentSelected" placeholder="Select Document">
        <mat-option *ngFor="let doc of projectDocuments" [value]="doc.projectDocumentID">
        {{ doc.documentName }}
       </mat-option>
     </mat-select>
  </mat-form-field> 

    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button class="calltoaction" type="submit" [disabled]="selectedFormId==0 && documentSelected==0"             
    (click)="SearchRecord()" color="primary">
       Search
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
    <button mat-flat-button class="calltoaction" type="submit"             
    (click)="clear()" color="primary">
      Clear      
    </button>
  </mat-dialog-actions>

</ng-template>


<ng-template #customize>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
    Select the columns you want to display in this list
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>


  <mat-dialog-content class="mat-typography">

    <div class="allheaders">
      <div class="fixrow sep">
        <span>Column Headers</span>
        <span> Active Columns</span>
      </div>

      <ng-container *ngFor="let item of displayColumn;let i = index">        
        <div class="sep">
          <span>{{item.fieldName}}</span>          
          <span>
            <mat-slide-toggle color="primary" [checked]="item.isDisplay" (change)="changedToggle(item,$event)">
            </mat-slide-toggle>           
          </span>
        </div>
      </ng-container>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!SubmitColumnsButton" (click)="onSubmitColumns()">Save</button>
  </mat-dialog-actions>
</ng-template>

<app-loader></app-loader>